import React from "react";
import "../HomeComponents/OverView.css";
import Hero from "../HomeComponents/Hero";
import OverView from "../HomeComponents/OverView";
import WhyAssetMax from "../HomeComponents/WhyAssetMax";
import Benefits from "../HomeComponents/Benefits";
import SubMenuBar from "../SubMenu/SubMenuBar";
import Faq from "../HomeComponents/Faq";
import Features from "../HomeComponents/Features";
import ContactUs from "../HomeComponents/ContactUs";
import UseCaseSlider from "../HomeComponents/UseCaseSlider";

const Block = ({ children }) => (
  <div className="py-12 sm:py-16">{children}</div>
);

const Divider = () => <hr className="w-full border-0 border-t border-gray-200" />;

const Home = () => {
  return (
    <main className="flex w-full flex-col font-['Poppins',sans-serif] bg-white text-[#4b5563]">
    {/* // <main className="flex w-full flex-col overflow-x-hidden font-['Poppins',sans-serif] bg-white text-[#4b5563]"> */}
      <Hero />
      <SubMenuBar />

      <OverView />
      <WhyAssetMax />

      {/* Statement banner with website styling */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#002C78] via-[#094191] to-[#002C78] px-5 py-12 text-white sm:px-14 sm:py-16">
        <div className="relative z-10 flex w-full flex-col items-center gap-4 text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-2 text-xs font-semibold tracking-widest text-[#ff9e80] backdrop-blur-md shadow-sm">
            The iAssetMax™ Advantage
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-[2.8rem] font-bold leading-[1.25]">
            Transition from using Excel and spreadsheets to adopting a
            cloud-based asset management software.
          </h2>
          <div className="w-20 h-1 bg-[#F23100] my-1"></div>
          <p className="max-w-[60rem] text-lg leading-[1.8] text-blue-100">
            Join thousands of organizations that have modernized their asset operations with iAssetMax™.
          </p>
        </div>
      </section>

      <Benefits />

      <Divider />
      <Block>
        <Features />
      </Block>

      <Divider />
      <Block>
        <UseCaseSlider />
      </Block>

      <Divider />
      <Block>
        <Faq />
      </Block>

      {/* Closing call to action with website theme */}
      <section className="flex w-full items-center justify-center bg-gradient-to-br from-[#f0f4fa] via-white to-[#f0f4fa] px-5 py-24 sm:px-14 border-t border-gray-200">
        <div className="mx-auto flex max-w-[56rem] flex-col items-center gap-6 text-center">
          {/* <div className="inline-block rounded-full bg-[#002C78]/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-[#002C78]">
            Get Started
          </div> */}
          <h2 className="text-3xl sm:text-4xl lg:text-[2.6rem] font-bold leading-tight text-[#002C78]">
            Simplify assets and equipment tracking with iAssetMax™
          </h2>
          <div className="w-20 h-1 bg-[#F23100]"></div>
          <p className=" text-lg leading-[1.8] text-[#4b5563]">
            From small teams to large enterprises, teams have found our asset
            management solution extremely useful for asset tracking,
            maintenance and streamlining their entire asset life cycle.
          </p>
          {/* <div className="mt-4 flex w-full flex-col items-stretch justify-center gap-4 sm:w-auto sm:flex-row sm:gap-6">
            <button
              type="button"
              className="h-[52px] rounded-lg bg-gradient-to-r from-[#002C78] to-[#2563EB] px-8 text-[1rem] font-semibold text-white shadow-md transition-all hover:shadow-lg hover:scale-105 active:scale-95 sm:min-w-[16rem]"
              onClick={() => {
                const el = document.getElementById("Overview");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              View more about iAssetMax
            </button>
            <button
              type="button"
              className="h-[52px] rounded-lg border-2 border-[#002C78] bg-white px-8 text-[1rem] font-semibold text-[#002C78] transition-all hover:bg-blue-50 sm:min-w-[16rem]"
              onClick={() => {
                const el = document.getElementById("Contact");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Start a project with us
            </button>
          </div> */}
        </div>
      </section>

      <ContactUs />
    </main>
  );
};

export default Home;
